import(/* webpackMode: "eager" */ "/home/runner/work/thi-beacon-frontend/thi-beacon-frontend/src/app/error.tsx");
